document.addEventListener('DOMContentLoaded', () => {
  const MINIMO = 30;

  function getPrice() {
    const priceEl =
      document.querySelector('.special-price') ||
      document.querySelector('.price');

    if (!priceEl) return null;

    return parseFloat(
      priceEl.innerText
        .replace('R$', '')
        .replace(/\./g, '')
        .replace(',', '.')
        .trim()
    );
  }

  function esconderParcelamento() {
    const price = getPrice();
    if (!price || price >= MINIMO) return;

    // Shopify Payment Terms (padrão)
    const paymentTerms = document.querySelector(
      'shopify-payment-terms, .shopify-payment-terms'
    );

    if (paymentTerms) {
      paymentTerms.style.display = 'none';
    }

    // fallback: qualquer texto com "x de R$"
    document.querySelectorAll('body *').forEach(el => {
      if (
        el.innerText &&
        /x\s+de\s+R\$\s*\d+/i.test(el.innerText)
      ) {
        el.style.display = 'none';
      }
    });
  }

  esconderParcelamento();
  setTimeout(esconderParcelamento, 500);
  setTimeout(esconderParcelamento, 1500);
  setTimeout(esconderParcelamento, 3000);
});
